// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.companyprofile {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  min-width: 328px;
  height: 100%;
}

.companyprofile .companyprofile-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
}

.companyprofile .companyprofile-table tbody tr {
  &:nth-child(2n) {
    background-color: var(--surface-primary);
  }
}

.companyprofile .companyprofile-table tbody td {
  padding: 8px 0px;
  font-size: 16px;
  height: 40px;
  box-sizing: border-box;
  line-height: 24px;
  &:first-child {
    min-width: 158px;
    text-align: left;
    color: var(--text-label);
    font-weight: 400;
    letter-spacing: 0px;
    vertical-align: top;
  }

  &:last-child {
    text-align: right;
    font-weight: 400;
    letter-spacing: 0px;
    color: var(--text-primary);
    word-break: break-word;
  }
}

.companyprofile .companyprofile-bizsummary {
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
}

.companyprofile .companyprofile-bizsummary a {
  color: var(--text-ticker);
  font-weight: 700;
  text-decoration: none;
}

.companyprofile .companyprofile-separator {
  border-bottom: 1px dashed var(--border-secondary);
}

.companyprofile-loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.companyprofile-empty-text {
  margin-top: 20px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #121212;
}

@container (min-width: 768px) {
  .companyprofile .flex-container {
    display: flex;
  }

  .companyprofile .companyprofile-bizsummary {
    width: 50%;
    min-width: 328px;
    text-align: left;
    padding-right: 16px;
  }

  .companyprofile .companyprofile-profile {
    display: contents;
  }

  .companyprofile .companyprofile-table {
    width: 50%;
    margin-top: 0px;
    height: 400px;
  }

  .companyprofile .companyprofile-separator {
    border-left: 1px solid var(--border-secondary);
    border-bottom: 0px;
    padding-right: 16px;
    margin-top: 0px;
  }
}

/* host pages often ship global link rules (a:hover, a:visited, ...). Scope to the
   widget and pin every link state so the embedding site can't recolour it. */
.companyprofile a.website,
.companyprofile a.website:link,
.companyprofile a.website:visited,
.companyprofile a.website:hover,
.companyprofile a.website:focus,
.companyprofile a.website:active {
  color: var(--text-ticker) !important;
  text-decoration: none !important;
  font-weight: 700;
  background-color: transparent !important;
  opacity: 1 !important;
}

.companyprofile a.website:hover {
  opacity: 0.9 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/CompanyProfileWidget/CompanyProfileWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB;IACE,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;EACf;;EAEA;IACE,8CAA8C;IAC9C,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;6EAC6E;AAC7E;;;;;;EAME,oCAAoC;EACpC,gCAAgC;EAChC,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".companyprofile {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  min-width: 328px;\n  height: 100%;\n}\n\n.companyprofile .companyprofile-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n}\n\n.companyprofile .companyprofile-table tbody tr {\n  &:nth-child(2n) {\n    background-color: var(--surface-primary);\n  }\n}\n\n.companyprofile .companyprofile-table tbody td {\n  padding: 8px 0px;\n  font-size: 16px;\n  height: 40px;\n  box-sizing: border-box;\n  line-height: 24px;\n  &:first-child {\n    min-width: 158px;\n    text-align: left;\n    color: var(--text-label);\n    font-weight: 400;\n    letter-spacing: 0px;\n    vertical-align: top;\n  }\n\n  &:last-child {\n    text-align: right;\n    font-weight: 400;\n    letter-spacing: 0px;\n    color: var(--text-primary);\n    word-break: break-word;\n  }\n}\n\n.companyprofile .companyprofile-bizsummary {\n  text-align: left;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.companyprofile .companyprofile-bizsummary a {\n  color: var(--text-ticker);\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.companyprofile .companyprofile-separator {\n  border-bottom: 1px dashed var(--border-secondary);\n}\n\n.companyprofile-loading-spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.companyprofile-empty-text {\n  margin-top: 20px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: #121212;\n}\n\n@container (min-width: 768px) {\n  .companyprofile .flex-container {\n    display: flex;\n  }\n\n  .companyprofile .companyprofile-bizsummary {\n    width: 50%;\n    min-width: 328px;\n    text-align: left;\n    padding-right: 16px;\n  }\n\n  .companyprofile .companyprofile-profile {\n    display: contents;\n  }\n\n  .companyprofile .companyprofile-table {\n    width: 50%;\n    margin-top: 0px;\n    height: 400px;\n  }\n\n  .companyprofile .companyprofile-separator {\n    border-left: 1px solid var(--border-secondary);\n    border-bottom: 0px;\n    padding-right: 16px;\n    margin-top: 0px;\n  }\n}\n\n/* host pages often ship global link rules (a:hover, a:visited, ...). Scope to the\n   widget and pin every link state so the embedding site can't recolour it. */\n.companyprofile a.website,\n.companyprofile a.website:link,\n.companyprofile a.website:visited,\n.companyprofile a.website:hover,\n.companyprofile a.website:focus,\n.companyprofile a.website:active {\n  color: var(--text-ticker) !important;\n  text-decoration: none !important;\n  font-weight: 700;\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n\n.companyprofile a.website:hover {\n  opacity: 0.9 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
